module.exports = "<div *ngIf=\"errorMessage\">{{ errorMessage }}</div>\n"